import { useMemo } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGetEventMediaQuery } from '../../../apps/admin/components/PhotoUploader/PhotoUploader.graphql.generated';
import type { GetEventMediaQuery } from '../../../apps/admin/components/PhotoUploader/PhotoUploader.graphql.generated';

type MediaItem = NonNullable<NonNullable<GetEventMediaQuery['eventByName']>['media']>[number];
export type MediaPhoto = Extract<MediaItem, { __typename?: 'MediaPhoto' }>;

/**
 * Reuses GetEventMedia from PhotoUploader.graphql.generated (same pattern as PhotoPicker, usePhotoUpload)
 * rather than defining a new query — a duplicate operation name causes codegen to produce an empty file.
 */
export const useEventMediaPhotos = (skip = false) => {
  const { eventHandle } = useEventInfo();

  const { data: eventMedia, loading: eventMediaLoading } = useGetEventMediaQuery({
    variables: { eventHandle: eventHandle || '' },
    skip: skip || !eventHandle,
    batchMode: 'fast',
  });

  const sortedEventMediaPhotos = useMemo(() => {
    const mediaPhotos = (eventMedia?.eventByName?.media?.filter(m => m.__typename === 'MediaPhoto') || []) as MediaPhoto[];
    return [...mediaPhotos].sort((a, b) => b.createdAt.milliseconds - a.createdAt.milliseconds);
  }, [eventMedia?.eventByName?.media]);

  return { sortedEventMediaPhotos, eventMediaLoading };
};
